import { DatePicker, Form, Modal, Select, Checkbox, Input, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { create_fuel_tank_reading, fuel_tank_master } from '../../Services/fuel management'

const TankReadingModal = ({ open, close, setRelaoder }) => {

    let [form] = Form.useForm()
    const [dropdowns, setDropdowns] = useState({
        fuel_tank: [],
        type: [
            { value: 1, label: "Manual" },
            { value: 2, label: "Remote Monitoring" },
        ],
    })

    let InputContainer = ({ label, children }) => {
        return <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span className="label">{label}</span>
            {children}
        </div>
    }

    const fetchFuelTank = async () => {
        let response = await fuel_tank_master()
        if (response?.httpStatus === 200) setDropdowns(prev => { return { ...prev, fuel_tank: response?.data?.map(x => { return { value: x?.id, label: x?.FTName } }) } })
    }

    // useEffect(() => {
    // }, [])

    useEffect(() => {
        if (open) {
            fetchFuelTank()
            form.resetFields()
            form.setFieldsValue({
                FuelTkID: 1
            })
        }
    }, [open])


    const onSubmit = async (values) => {
        let body = {
            ...values,
            ReadType: values?.ReadType + ""
        }
        let response = await create_fuel_tank_reading(body)
        if (response?.httpStatus === 200) {
            message?.success("Fuel Tank Reading Added!")
            close()
            form.resetFields()
            setRelaoder(prev => prev = !prev)

        }
    }

    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
                form.resetFields()
            }}
            footer={null}
            title="Add Fuel Tank Reading"
        >
            <Form onFinish={onSubmit} onFinishFailed={err => console.log(err)} form={form}>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>

                        <InputContainer label={"Fuel Tank"}>
                            <Form.Item name="FuelTkID" style={{ margin: "0" }}
                                rules={[{ required: true, message: 'Please select a fuel tank!' }]}
                            >
                                <Select
                                    allowClear={false}
                                    showSearch
                                    options={dropdowns?.fuel_tank}
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    style={{ width: "194px" }}

                                />
                            </Form.Item>
                        </InputContainer>
                        <InputContainer label={"Type"}>
                            <Form.Item name="ReadType" style={{ margin: "0" }}
                                rules={[{ required: true, message: 'Please select a Type!' }]}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    options={dropdowns?.type}
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    style={{ width: "194px" }}
                                />
                            </Form.Item>
                        </InputContainer>
                        <InputContainer label={"Gallons"}>
                            <Form.Item name="Gallons" style={{ margin: "0" }}
                                rules={[{ required: true, message: 'Please enter Gallon!' }]}
                            >
                                <Input
                                    type="text"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onPaste={(event) => {
                                        const pastedData = event.clipboardData.getData('Text');
                                        if (!/^\d+$/.test(pastedData)) {
                                            event.preventDefault();
                                        }
                                    }} />
                            </Form.Item>
                        </InputContainer>

                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button
                            type='submit'
                            style={{ background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "200px", height: "50px", cursor: "pointer" }}>
                            Submit
                        </button>
                    </div>
                </div>
            </Form>

        </Modal>
    )
}

export default TankReadingModal